// SPDX-License-Identifier: AGPL-3.0-or-later

export const SOUNDBOARD_SOUND_PATH_PREFIX = 'soundboard-sounds';

export const SOUNDBOARD_MAX_SIZE_BYTES = 512_000;
export const SOUNDBOARD_MAX_DURATION_MS = 5200;

export const GUILD_NOTIFICATION_SOUND_MIN_DURATION_MS = 100;
export const GUILD_NOTIFICATION_SOUND_MAX_DURATION_MS = 2000;
